import { ExpenditureCategory } from '../expenditure-categories/expenditure-category';

export class Expenditure {
  public id?: string;
  public expenditureCategory?: ExpenditureCategory;
  public name: string;
}
